var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-col',{staticClass:"p-0 white",attrs:{"cols":_vm.cols}},[_c('v-row',{staticClass:"m-0"},[_c('v-col',{staticClass:"p-0 white"},[_c('div',{staticClass:"font-weight-medium pt-4 pb-3 box-title",class:{
          'vuetify-table-header': !_vm.isClient,
          'vuetify-table-header-cli': _vm.isClient,
        }},[_vm._v(" "+_vm._s(_vm.title)+" ")])])],1),_c('v-row',{staticClass:"m-0"},[_c('v-col',{staticClass:"p-0 white"},[_vm._t("default")],2)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }